import { useState } from 'react';

// Small viewport, or a touch-only device (no hover, coarse pointer). Evaluated once on mount —
// a desktop user resizing the window is not bounced mid-session.
export const MOBILE_QUERY = '(max-width: 900px), (hover: none) and (pointer: coarse)';

const useIsMobile = (): boolean => {
  const [isMobile] = useState<boolean>(
    () => typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches
  );
  return isMobile;
};

export default useIsMobile;
